package one.healthium.login.ui.magic_link

data class MagicLinkUiState(
    val loading: Boolean = false,
    val magicLinkUiOptions: MagicLinkUiOptions = MagicLinkUiOptions(),
)
